import { h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'

const TopicFavorite = ({ className = '', isActive }: { className?: string, isActive: boolean }) => {
  return (
    <div className={className}>
      <Icon
        icon={isActive ? 'star' : 'starBorder'}
        size={16}
      />
      <span className='post-footer-item-text'><Phrase p='Subscribe' /></span>
    </div>
  )
}

export default TopicFavorite
